import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import APIURL from "../../helper/environment";

import { Button, Form, FormGroup, Input, Label } from "reactstrap";

const Login = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    let url = `${APIURL}/owner/login`;

    let bodyObject = {
      email,
      password,
    };

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      headers: myHeaders,
      method: "POST",
      body: JSON.stringify(bodyObject),
    };

    try {
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      if (
        data.message === "Parking Lot Owner Logged In" ||
        data.message === "Administrator Logged In"
      ) {
        props.updateToken(data.token);
        navigate("/Lots"); //! Need to add navigation point
      }
    } catch (error) {
      console.error(error.message);
    }
  }

  return (
    <>
      <div className="App">
        <div className="auth-form-container">
          <h2 className="text-center">Login</h2>

          <Form className="login-form" onSubmit={handleSubmit}>
            <FormGroup>
              <Label>Email:</Label>
              <Input
                value={email}
                type="email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormGroup>

            <FormGroup>
              <Label>Password:</Label>
              <Input
                value={password}
                type="password"
                onChange={(e) => setPassword(e.target.value)}
              />
            </FormGroup>
            <div className="text-center d-grid   gap-2 mb-4">
              <Button type="submit" color="warning">
                Login
              </Button>
            </div>

            <div className="d-flex justify-content-right text-right mx-3 mb-4">
              <a
                className="justify-content-right text-right"
                href="./ForgetPassword"
              >
                Forgot password?
              </a>
            </div>

            <div className="d-flex flex-row align-items-center justify-content-center pb-4 mb-4">
              <p className="mb-0">Don't have an account?</p>

              <Button
                onClick={() => props.setCurrentForm("signup")}
                // outline
                className="mx-2"
                color="dark"
              >
                Sign Up
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default Login;
